import React, { Component } from 'react';
import {
    domainCoverageIsLoadedSelector,
    domainsAtRejectSelector,
} from '../../selectors/domain-coverage-selectors';
import {
    formattedEndDateSelector,
    formattedStartDateSelector
} from '../../selectors/reports-selectors';

import ProgressBulletGroup from '../../components/progress-bullet-group';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getDifferenceInRange } from '../../../utils/report-utils';

export class DomainCoverageProgressBulletsContainer extends Component{
    buildBulletMap = () => {
        const {
            startDate, endDate,
            reject: { currentTotalReject, currentPercentReject, rejectDelta, rejectDeltaRate }
        } = this.props;

        const numberOfDays = getDifferenceInRange( startDate, endDate );
        const action = Math.sign( rejectDelta ) >= 0 ? 'added' : 'removed';
        const preposition = Math.sign( rejectDelta ) >= 0 ? 'to' : 'from';
        const trend = Math.sign( rejectDelta ) >= 0 ? 'increase' : 'decrease';
        const absoluteRejectDelta = Math.abs( rejectDelta );
        const absoluteRejectDeltaRate = Math.abs( rejectDeltaRate );

        return [
            { text: `${currentTotalReject} (${currentPercentReject}%) of our domains had blocking policies on ${endDate}.` },
            { text: `
                We ${action} blocking policies ${preposition} ${absoluteRejectDelta}
                ${absoluteRejectDelta === 1 ? 'domain' : 'domains'} (a ${absoluteRejectDeltaRate}% ${trend}) over
                ${numberOfDays} days (between ${startDate} and ${endDate}).
            ` },
            { text: 'Fully-protected organizations have blocking policies on 100% of their domains.' }
        ];
    }

    render(){
        const { isLoaded } = this.props;

        return (
            isLoaded &&
            <ProgressBulletGroup bullets={this.buildBulletMap()} />
        );
    }
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        endDate: formattedEndDateSelector( state ),
        isLoaded: domainCoverageIsLoadedSelector( state ),
        reject: domainsAtRejectSelector( state ),
        startDate: formattedStartDateSelector( state ),
    };
};

DomainCoverageProgressBulletsContainer.propTypes = {
    endDate: PropTypes.string.isRequired,
    isLoaded: PropTypes.bool.isRequired,
    reject: PropTypes.shape( {
        currentPercentReject: PropTypes.string.isRequired,
        currentTotalReject: PropTypes.number.isRequired,
        rejectDelta: PropTypes.number.isRequired,
        rejectDeltaRate: PropTypes.string.isRequired
    } ),
    startDate: PropTypes.string.isRequired,
};

export default connect( mapStateToProps )( DomainCoverageProgressBulletsContainer );
